import { useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { initializePnpDeposit } from '../pnpCashier.api';
import type { InitializeDepositRequest, InitializeDepositResponse } from '../pnpCashier.types';
import { pnpRetryStore } from '../pnpRetryStore';

export const useInitializeDeposit = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showBoundary } = useErrorBoundary();

  const submit = async (
    payload: InitializeDepositRequest,
  ): Promise<InitializeDepositResponse | null> => {
    setIsSubmitting(true);
    pnpRetryStore.set(payload);

    try {
      const response = await initializePnpDeposit(payload);

      return response;
    } catch (err) {
      console.error('[PnpCashier] Initialize deposit failed:', err);
      const error = new Error('pnp_init_failed');
      error.name = 'pnp_init_failed';
      showBoundary(error);

      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submit, isSubmitting };
};
